import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getSupplierForecastTableData = createApi(`SupplierForecastTableDataSlice`,"GET");

const SupplierForecastTableDataSlice = createSlice({
  name: 'SupplierForecastTableDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupplierForecastTableData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSupplierForecastTableData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSupplierForecastTableData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SupplierForecastTableDataSlice.reducer;